//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getDiscountList } from '@/api/buy'
export default {
  name: 'coupon',
  data () {
    return {
      list: [],
      title: '我的优惠券'
    }
  },
  created () {
    this.getDiscountList()
  },
  methods: {
    onClickLeft () {
      this.$router.goBack()
    },
    selectdCoupon (item) {
      if (item.packageId !== this.$route.query.id * 1) return
      this.$bus.$emit('changeCoupon', item)
      this.$router.goBack()
    },
    checkState (item) {
      if (item.packageId !== this.$route.query.id * 1) {
        return true
      }
    },
    getDiscountList () {
      getDiscountList({
        pageNum: 1,
        pageSize: 50,
        status: 1
      }).then(res => {
        this.list = res.data.list
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/coupon.vue